<template>
  <div class="menu">
    <li
      class="list-group-item"
      v-on:click="isMenuOpened = !isMenuOpened"
    >
      <img class="menu-logo" :src="app_root + '/assets/common/img/printlink/printer.svg'" alt="printer" align="middle">
      <LabelFunMessage fcontId="0" msgkey="129" />
      <span
        v-if="!isMenuOpened"
        class="glyphicon glyphicon-chevron-down"
        aria-hidden="true"
      ></span>
      <span
        v-if="isMenuOpened"
        class="glyphicon glyphicon-chevron-up"
        aria-hidden="true"
      >
      </span>
    </li>

    <collapse v-model="isMenuOpened" class="app-menu">
      <div class="app-menu-inner">
        <p class="app-message">
          <LabelFunMessage fcontId="0" msgkey="19" />
        </p>
        <div class="how_step">
          <p class="introduction"></p>
          <div class="YoutubeWrapper">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/MF99Nw0pAYA?enablejsapi=1"
              frameborder="0"
              allowfullscreen="allowfullscreen"
              class="center-block"
            ></iframe>
          </div>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";
import { Collapse } from "uiv";

export default {
  name: "PrintMenuPrinter",
  components: {
    LabelFunMessage,
    Collapse
  },
  data() {
    return {
      isMenuOpened: false,
      app_root: process.env.VUE_APP_ROOT
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
}
</style>